export default __webpack_public_path__ + "img/cb9ce633e05f7852c4f741da15d3230e.png";